import { AccessTimeRounded, AdminPanelSettings, AnalyticsRounded, ApartmentRounded, ApprovalRounded, GamepadRounded, Groups3Rounded, HomeRounded, OpenInNewRounded } from '@mui/icons-material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import BarChartIcon from '@mui/icons-material/BarChart'
import BusinessIcon from '@mui/icons-material/Business'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import CategoryIcon from '@mui/icons-material/Category'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DescriptionIcon from '@mui/icons-material/Description'
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat'
import EditIcon from '@mui/icons-material/Edit'
import Groups3Icon from '@mui/icons-material/Groups3'
import HubIcon from '@mui/icons-material/Hub'
import InventoryIcon from '@mui/icons-material/Inventory'
import PreviewIcon from '@mui/icons-material/Preview'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SchemaIcon from '@mui/icons-material/Schema'
import StorageIcon from '@mui/icons-material/Storage'
import SummarizeIcon from '@mui/icons-material/Summarize'
import { Route } from './Routing'

export type IconName = Route | 'clock' | 'link' | 'thermometer' | 'business' | 'category'
interface P {
    icon: IconName
    style?: React.CSSProperties
}

function RouteIcon({ icon, style }: P) {
    switch (icon) {
        case 'overview': return <HomeRounded fontSize='inherit' style={style} />
        case 'contracts': return <AnalyticsRounded fontSize='inherit' style={style} />
        case 'tcoc-summary': return <SummarizeIcon fontSize='inherit' style={style} />
        case 'playground': return <GamepadRounded fontSize='inherit' style={style} />
        case 'workflows': return <DashboardIcon fontSize='inherit' style={style} />
        case 'clock': return <AccessTimeRounded fontSize='inherit' style={style} />
        case 'link': return <OpenInNewRounded fontSize='inherit' style={style} />
        case 'network': return <ApartmentRounded fontSize='inherit' style={style} />
        case 'members': return <Groups3Rounded fontSize='inherit' style={style} />
        case 'contract-details': return <DescriptionIcon fontSize='inherit' style={style} />
        case 'claims': return <ReceiptIcon fontSize='inherit' style={style} />
        case 'contract-editor': return <EditIcon fontSize='inherit' style={style} />
        case 'contracts-manager': return <InventoryIcon fontSize='inherit' style={style} />
        case 'fund': return <AccountBalanceWalletIcon fontSize='inherit' style={style} />
        case 'funds': return <AccountBalanceIcon fontSize='inherit' style={style} />
        case 'provider': return <BusinessCenterIcon fontSize='inherit' style={style} />
        case 'provider-group': return <Groups3Icon fontSize='inherit' style={style} />
        case 'thermometer': return <DeviceThermostatIcon fontSize='inherit' style={style} />
        case 'business': return <BusinessIcon fontSize='inherit' style={style} />
        case 'category': return <CategoryIcon fontSize='inherit' style={style} />
        case 'flows': return <HubIcon fontSize='inherit' style={style} />
        case 'flow': return <AccountTreeIcon fontSize='inherit' style={style} />
        case 'settlement-details': return <StorageIcon fontSize='inherit' style={style} />
        case 'quality-measures-breakdown':
        case 'funds-breakdown':
        case 'claims-breakdown':
        case 'provider-performance-breakdown': return <BarChartIcon fontSize='inherit' style={style} />
        case 'tooltip-admin': return <PreviewIcon fontSize='inherit' style={style} />
        case 'contract-schema' : return <SchemaIcon fontSize='inherit' style={style} />
        case 'users-approvals' : return <ApprovalRounded fontSize='inherit' style={style} />
        case 'administrator' : return <AdminPanelSettings fontSize='inherit' style={style} />

        default: return null
    }
}

export default RouteIcon
